import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/AppShell";
import { RouteGuard } from "@/components/layout/RouteGuard";
import ApiKeysPage from "@/features/api-keys";

/**
 * API keys — third screen off the legacy tree, and the first nested route.
 *
 * The whole feature came with it: the page, its two dialogs, its query hooks and
 * its service module had no consumers outside this screen, so they now live under
 * features/api-keys/ rather than being scattered across components/, hooks/ and
 * services/. DataTable stayed in components/ — it is generic table plumbing that
 * happens to have one caller today, not API-key code.
 *
 * The legacy call was <DashboardLayout title={...}> with no `fullHeight`, so the
 * content sat in a <Container maxWidth="xl">. That is AppShell's default now, so
 * there is nothing to pass here.
 */
const ApiKeysRoute = () => {
  const { t } = useTranslation();
  return (
    // Mirrors the legacy route exactly: <ProtectedRoute><ApiKeyRoute>.
    <RouteGuard allow={(p) => p.canViewApiKey}>
      <AppShell title={t("apiKeys.title")}>
        <ApiKeysPage />
      </AppShell>
    </RouteGuard>
  );
};

export const Route = createFileRoute("/platform/security/api-keys")({
  component: ApiKeysRoute,
});
